import {base64encode,base64decode} from "@/common/base64"

export default {
    mounted() {
        const vm = this;
        if (!this.oauth && !this.$organization.sso) this.admin_login = true;
        if (this.$organization.sso) {  // 如果设置的是sso 那么就直接跳转连管理员输入都不显示
            if (!this.$route.query.ticket) { // read user info
                vm.jumpToSSO();
                return;
            }
        }
        if (this.$organization.oauth || this.$organization.sso) { // 这是显示管理员界面+单点登录界面
            if (this.$route.query.ticket) { // read user info
                //这里的t还是加密状态，否则api访问cas会错误
                this.$api('SSO?ticket='+this.$route.query.ticket+"&_t="+(this.$route.query._tt || ""), null).then(res => {
                    if (res.data.success) {
                        vm.handleSSOSuccess(res);
                    } else {
                        vm.$messageBox.error('错误的SSO返回信息,重新登录', null, () => {
                            this.jumpToSignIn();
                        });
                    }
                });
            } else if (this.$route.query.code) {
                this.$api('SSO', {code: this.$route.query.code, state: this.$route.query.state, '_t':this.$route.query._tt || ""}, 1).then(res => {
                    if (res.data.success) {
                        if (res.data.data.error) {
                            this.show_login_error = true;
                            this.error_message = res.data.data.message;
                        } else {
                            vm.handleSSOSuccess(res);
                        }
                    } else {
                        this.$messageBox.error(res.data.text, null, () => {
                            this.jumpToSignIn()
                        })
                    }
                }).catch(() => {
                    this.ready = true;
                    this.page_ready = true;

                });
            } else if (this.$route.query.from === 'portal') {
                //从主页来的，直接去sso，不经过登录页面
                vm.jumpToOAuth2( this.$route.query._t);
            } else {
                this.ready = true;
                this.page_ready = true;
            }
        } else {
            this.ready = true;
            this.page_ready = true;
        }
    },
    computed: {
        oauth() {
            return !!this.$organization.oauth;
        }
    },
    methods: {
        handleSSOSuccess(res){
            this.setUserInfo(res.data.data);
            //成功后，跳转的话，需要将原来编码的返回地址decode
            let ret = "/";
            if (this.$route.query._tt) {
                ret = decodeURIComponent( base64decode( this.$route.query._tt ) );
            }
            window.location.href = ret;
        },
        jumpToOAuth2(ret) {
            // 跳转如认证的时候，增加一个_t为了防止出错，进行base64编码
            const return_url = this.$organization.signin_url + (ret ? '?_tt=' + base64encode(ret) : '');
            window.location.href = this.$organization.oauth
                + encodeURIComponent(return_url);
        },
        jumpToSSO(ret) {
            // 跳转如认证的时候，增加一个_t为了防止出错，进行base64编码
            const return_url = this.$organization.signin_url + (ret ? '?_tt=' + base64encode(ret) : '');
            window.location.href = this.$organization.sso
                + encodeURIComponent(return_url);
        },
        jumpToSignIn() {
            //出错的话也要解码一下
            if (this.$route.query._tt) {
                window.location.href = this.$organization.sso + "?_t=" + decodeURIComponent(base64decode(this.$route.query._tt))
            } else {
                window.location.href = this.$organization.sso;
            }
            //this.show_login_error = false;
            //this.ready = true;
        },
    },
}
